module.exports = __webpack_public_path__ + "img/20200507_141052.ef36585c.jpg";